import { HttpClient } from '@angular/common/http'
import { TranslateLoader } from '@ngx-translate/core'
import { forkJoin, Observable, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'

/** Core files loaded at startup — needed by layout, sidebar, shared UI, media library */
const CORE_FILES: string[] = ['_common', '_error', '_breadcrumb', '_sidebar', '_primeng', '_layout', 'themes']

export class MultiFileTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private basePath: string = './assets/i18n') {}

  getTranslation(lang: string): Observable<Record<string, any>> {
    const requests = CORE_FILES.map(file =>
      this.http.get<Record<string, any>>(`${this.basePath}/${lang}/${file}.json`).pipe(
        catchError(err => {
          // A swallowed failure here poisons the store with an empty table
          // that ngx-translate treats as "loaded" — never fail silently.
          console.error(`[i18n] failed to load core file ${this.basePath}/${lang}/${file}.json`, err)
          return of({})
        }),
      ),
    )

    return forkJoin(requests).pipe(
      map(results => {
        const merged: Record<string, any> = {}
        for (const partial of results) {
          this.deepMerge(merged, partial)
        }
        return merged
      }),
    )
  }

  private deepMerge(target: Record<string, any>, source: Record<string, any>): Record<string, any> {
    for (const key of Object.keys(source)) {
      if (
        source[key] &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key]) &&
        target[key] &&
        typeof target[key] === 'object' &&
        !Array.isArray(target[key])
      ) {
        this.deepMerge(target[key], source[key])
      } else {
        target[key] = source[key]
      }
    }
    return target
  }
}
